import React, { useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { AiOutlineClose } from 'react-icons/ai';
import { cx, useOverlay } from './hooks';

/** Side panel rendered in a portal. placement: 'right' (default) | 'left'. */
const Drawer = ({
  open,
  onClose,
  title,
  extra,
  children,
  footer,
  placement = 'right',
  width,
  closable = true,
  maskClosable = true,
  className,
  bodyClassName,
}) => {
  const panelRef = useRef(null);
  const titleId = useId();

  useOverlay(open, onClose, panelRef);

  if (!open) return null;

  const panelStyle =
    width !== undefined ? { '--drawer-w': typeof width === 'number' ? `${width}px` : width } : undefined;

  return createPortal(
    <>
      <div className="drawer-backdrop" onClick={maskClosable ? onClose : undefined} />
      <div
        ref={panelRef}
        className={cx('drawer', placement === 'left' && 'is-left', className)}
        style={panelStyle}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        tabIndex={-1}
      >
        {(title || closable || extra) && (
          <div className="drawer-head">
            {closable && (
              <button type="button" className="drawer-close" onClick={onClose} aria-label="Close">
                <AiOutlineClose />
              </button>
            )}
            <div className="drawer-title" id={titleId}>
              {title}
            </div>
            {extra}
          </div>
        )}
        <div className={cx('drawer-body', bodyClassName)}>{children}</div>
        {footer && <div className="drawer-foot">{footer}</div>}
      </div>
    </>,
    document.body
  );
};

export default Drawer;
